import type { ComponentType, SVGProps } from "react";
import { Brain, Clapperboard, Home, LibraryBig, MessageCircle, Settings, Sparkles } from "lucide-react";

interface NavItem {
  title: string;
  url: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  badge?: string;
  description?: string;
  mobile?: boolean;
}

interface NavSection {
  title: string;
  items: NavItem[];
}

const leaderCoachNavItem: NavItem = {
  title: "My Coach",
  url: "/leader/coach",
  icon: MessageCircle,
  badge: "messages"
};

export function resolveLeaderCoachBridgeVisibility({
  hasCoachConnection,
  invitationContextLoading,
  accountModeLoading,
  accountMode,
  previewEnabled,
}: {
  hasCoachConnection: boolean;
  invitationContextLoading: boolean;
  accountModeLoading: boolean;
  accountMode?: string | null;
  previewEnabled: boolean;
}): boolean {
  if (previewEnabled) return false;
  if (hasCoachConnection || invitationContextLoading || accountModeLoading) return false;
  return accountMode !== "coach_led";
}

export function buildLeaderNavSections({
  hasCoachConnection,
  includeSettings = true,
  showLeadershipFrameworkLink = false,
}: {
  hasCoachConnection: boolean;
  includeSettings?: boolean;
  showLeadershipFrameworkLink?: boolean;
}): NavSection[] {
  const veeraTitle = "Coach Veera";

  return [{
    title: "Core",
    items: [{
      title: "Today",
      url: "/today",
      icon: Home
    }, {
      title: "Schedule",
      url: "/moments",
      icon: Clapperboard
    }, {
      title: "Meeting Insights",
      url: "/insights",
      icon: Brain
    }, {
      title: "Leadership Insights",
      url: "/shared-memory",
      icon: LibraryBig,
    }, {
      title: veeraTitle,
      url: "/veera",
      icon: Sparkles
    },
    ...(hasCoachConnection ? [leaderCoachNavItem] : []),
    ...(showLeadershipFrameworkLink ? [{
      title: "Leadership Framework",
      url: "/shared-memory#leadership-lens",
      icon: Sparkles,
      mobile: false,
    }] : []),
    ...(includeSettings ? [{
      title: "Settings",
      url: "/settings",
      icon: Settings,
      mobile: false,
    }] : [])]
  }];
}

export function resolveLeaderBrandLabel(hasCoachConnection: boolean) {
  return hasCoachConnection ? "Coach VEERA" : "Veera";
}
